import zipcodeService from '@wwdev/zipcode/zipcodeService';
import Zipcode, {defaultConfig} from '@wwdev/zipcode/Zipcode';
import Events from "@wwdev/bootstrap/Events";

class CustomZipcode extends Zipcode {
	constructor($scope,config) {
		super($scope, config);
	}

	findStreetAndTown() {
		let country = this.$country.val();
		// Country ID and Name are both valid.
		if (country != 146 && country != 'Nederland') {
			this.$street.val('').removeAttr('readonly');
			this.$town.val('').removeAttr('readonly');
			return;
		}

		let zipcode = this.$zipcode.val();
		let streetNumber = this.$streetNumber.val();

		if(streetNumber) {
			let res = streetNumber.match(/(\d*).*/);
			streetNumber = res[1];
		}

		if ((zipcode == '' || zipcode.length < 6) || streetNumber == '') return;

		Events.trigger('wwdev.zipcode.getCityAndStreet.before',[zipcode,streetNumber]);
		zipcodeService.getCityAndStreet(zipcode, streetNumber)
			.then(this.onSuccess.bind(this))
			.fail(this.onError.bind(this))
			.then(this.onAlways.bind(this));
	}
}

export {
	zipcodeService as zipcodeService,
	defaultConfig
}
export default CustomZipcode;